document.documentElement.className = document.documentElement.className.replace('no-js', 'js');
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

class NayaSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.naya-slider__track');
    this.prev = this.querySelector('[data-slider-prev]');
    this.next = this.querySelector('[data-slider-next]');
    this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'));
    if (!this.track) return;

    this.prev && this.prev.addEventListener('click', () => this.move(-1));
    this.next && this.next.addEventListener('click', () => this.move(1));
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.goTo(Number(dot.dataset.sliderIndex || 0)));
    });
    this.track.addEventListener('scroll', () => this.updateDots(), { passive: true });
    window.addEventListener('resize', () => this.updateDots());
    this.addEventListener('pointerenter', () => this.pause());
    this.addEventListener('pointerleave', () => this.play());
    this.addEventListener('focusin', () => this.pause());
    this.addEventListener('focusout', () => this.play());
    document.addEventListener('visibilitychange', () => {
      document.hidden ? this.pause() : this.play();
    });

    document.addEventListener('shopify:section:select', (event) => {
      if (this.closest(`[data-section-id="${event.detail.sectionId}"]`) || event.target.contains(this)) this.pause();
    });
    document.addEventListener('shopify:block:select', (event) => {
      if (event.target && this.contains(event.target)) this.pause();
    });
    document.addEventListener('shopify:section:deselect', () => this.play());
    document.addEventListener('shopify:block:deselect', () => this.play());

    this.updateDots();
    this.play();
  }

  move(direction) {
    const slide = this.track.querySelector('.naya-slider__slide');
    const gap = 14;
    const amount = slide ? slide.getBoundingClientRect().width + gap : this.track.clientWidth * 0.86;
    this.track.scrollBy({ left: amount * direction, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  goTo(index) {
    const slides = this.track.querySelectorAll('.naya-slider__slide');
    const target = slides[index];
    if (!target) return;
    const left = target.offsetLeft - this.track.offsetLeft;
    this.track.scrollTo({ left, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  updateDots() {
    if (!this.dots.length || !this.track) return;
    const slide = this.track.querySelector('.naya-slider__slide');
    const slideWidth = slide ? slide.getBoundingClientRect().width : this.track.clientWidth;
    const index = Math.max(0, Math.min(this.dots.length - 1, Math.round(this.track.scrollLeft / Math.max(slideWidth, 1))));
    this.dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);
      if (isActive) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  canAutoplay() {
    return this.dataset.autoplay === 'true'
      && !document.body.classList.contains('global-autoplay-disabled')
      && !reduceMotion
      && this.track
      && this.track.scrollWidth > this.track.clientWidth + 8;
  }

  play() {
    this.pause();
    if (!this.canAutoplay()) return;

    const interval = Number(this.dataset.interval || document.body.dataset.sliderInterval || 3800);
    this.autoplayTimer = window.setInterval(() => {
      if (!this.canAutoplay()) {
        this.pause();
        return;
      }

      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 4;
      if (this.track.scrollLeft >= maxScroll) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        this.move(1);
      }
    }, interval);
  }

  pause() {
    if (this.autoplayTimer) {
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }
}

if (!customElements.get('naya-slider')) {
  customElements.define('naya-slider', NayaSlider);
}

const formatMoney = (cents) => {
  try {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
  } catch (error) {
    return `R$ ${(cents / 100).toFixed(2).replace('.', ',')}`;
  }
};

const cartDrawer = document.querySelector('[data-cart-drawer]');
const cartBody = document.querySelector('[data-cart-drawer-body]');
const cartSubtotal = document.querySelector('[data-cart-subtotal]');
const cartCountEls = document.querySelectorAll('[data-cart-count]');
const searchDrawer = document.querySelector('[data-search-drawer]');
let predictiveSearchTimer = null;
let predictiveSearchController = null;

function openCartDrawer() {
  if (!cartDrawer || document.body.classList.contains('cart-drawer-disabled')) return;
  cartDrawer.hidden = false;
  requestAnimationFrame(() => document.body.classList.add('cart-drawer-open'));
}

function closeCartDrawer() {
  document.body.classList.remove('cart-drawer-open');
  if (!cartDrawer) return;
  setTimeout(() => { cartDrawer.hidden = true; }, reduceMotion ? 0 : 260);
}

function openSearchDrawer() {
  if (!searchDrawer) return;
  searchDrawer.hidden = false;
  requestAnimationFrame(() => {
    document.body.classList.add('search-drawer-open');
    const input = searchDrawer.querySelector('[data-search-input]');
    if (input) input.focus();
  });
}

function closeSearchDrawer() {
  document.body.classList.remove('search-drawer-open');
  if (!searchDrawer) return;
  setTimeout(() => { searchDrawer.hidden = true; }, reduceMotion ? 0 : 260);
}

function escapeHTML(value) {
  return String(value || '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[char]));
}

function getProductImage(product) {
  return product && (
    product.featured_image && (product.featured_image.url || product.featured_image)
    || product.image
    || product.featured_media && product.featured_media.preview_image && product.featured_media.preview_image.url
  );
}

function getProductPrice(product) {
  const price = product && (product.price || product.price_min || product.variants && product.variants[0] && product.variants[0].price);
  if (typeof price === 'number') return formatMoney(price);
  if (typeof price === 'string' && /^[0-9]+(\.[0-9]{1,2})?$/.test(price)) return formatMoney(Math.round(Number(price) * 100));
  return price ? String(price) : '';
}

function getPredictiveScope(input) {
  return input && input.closest('[data-header-search], [data-search-drawer]') || document;
}

function renderPredictiveResults(products, query, input) {
  const scope = getPredictiveScope(input);
  const wrapper = scope.querySelector('[data-predictive-search]');
  const results = scope.querySelector('[data-predictive-search-results]');
  const empty = scope.querySelector('[data-predictive-search-empty]');
  const allLink = scope.querySelector('[data-predictive-search-all]');
  if (!wrapper || !results || !empty) return;

  if (allLink) allLink.href = `/search?type=product&q=${encodeURIComponent(query)}`;
  wrapper.hidden = false;

  if (!products.length) {
    results.innerHTML = '';
    empty.hidden = false;
    return;
  }

  empty.hidden = true;
  results.innerHTML = products.slice(0, 5).map((product, index) => {
    const image = getProductImage(product);
    const price = getProductPrice(product);
    const title = escapeHTML(product.title);
    const url = product.url || `/search?type=product&q=${encodeURIComponent(product.title || query)}`;
    const vendor = escapeHTML(product.vendor || product.type || 'Naya Beachwear');
    return `
      <a class="predictive-search__item" href="${url}" style="animation-delay:${index * 45}ms">
        <span class="predictive-search__media">
          ${image ? `<img src="${image}" alt="${title}" loading="lazy">` : ''}
        </span>
        <span>
          <span class="predictive-search__title">${title}</span>
          <span class="predictive-search__meta caption">${vendor}</span>
        </span>
        ${price ? `<span class="predictive-search__price">${escapeHTML(price)}</span>` : ''}
      </a>
    `;
  }).join('');
}

function clearPredictiveResults(input) {
  const scope = getPredictiveScope(input || document.activeElement && document.activeElement.closest('[data-predictive-search-input]'));
  const wrapper = scope.querySelector('[data-predictive-search]');
  const results = scope.querySelector('[data-predictive-search-results]');
  const empty = scope.querySelector('[data-predictive-search-empty]');
  if (wrapper) wrapper.hidden = true;
  if (results) results.innerHTML = '';
  if (empty) empty.hidden = true;
}

async function fetchPredictiveSearch(query, input) {
  if (predictiveSearchController) predictiveSearchController.abort();
  predictiveSearchController = new AbortController();
  const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
  const endpoint = `${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last`;
  const response = await fetch(endpoint, {
    headers: { Accept: 'application/json' },
    signal: predictiveSearchController.signal
  });
  const data = await response.json();
  const products = data && data.resources && data.resources.results && data.resources.results.products || [];
  renderPredictiveResults(products, query, input);
}

function updateFreeShipping(cart) {
  document.querySelectorAll('[data-free-shipping]').forEach((wrapper) => {
    const threshold = Number(wrapper.dataset.threshold || 49900);
    const remaining = Math.max(threshold - cart.total_price, 0);
    const percent = Math.min((cart.total_price / threshold) * 100, 100);
    const bar = wrapper.querySelector('[data-free-shipping-bar]');
    const text = wrapper.querySelector('[data-free-shipping-text]');
    if (bar) bar.style.width = `${percent}%`;
    if (text) {
      text.textContent = remaining > 0
        ? `Faltam ${formatMoney(remaining)} para o frete especial`
        : 'Frete especial desbloqueado';
    }
  });
}

function renderCart(cart) {
  cartCountEls.forEach((el) => { el.textContent = cart.item_count; });
  if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
  updateFreeShipping(cart);
  if (!cartBody) return;

  if (!cart.items.length) {
    cartBody.innerHTML = `
      <div class="empty-state">
        <h3 class="display-s">Sua sacola está vazia.</h3>
        <p class="body-m">Escolha uma peça para começar seu próximo destino.</p>
      </div>`;
    return;
  }

  cartBody.innerHTML = cart.items.map((item) => `
    <div class="cart-drawer__item">
      <button class="cart-drawer__remove" type="button" data-line-key="${escapeHTML(item.key)}" data-cart-remove aria-label="Remover ${escapeHTML(item.product_title)} da sacola">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M5 7h14"></path>
          <path d="M9 7V5.7C9 5 9.6 4.5 10.3 4.5h3.4c.7 0 1.3.5 1.3 1.2V7"></path>
          <path d="m7.4 7 .8 12h7.6l.8-12"></path>
          <path d="M10.5 10.5v5.6"></path>
          <path d="M13.5 10.5v5.6"></path>
        </svg>
      </button>
      <a class="cart-drawer__media" href="${escapeHTML(item.url)}">
        ${item.image ? `<img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.product_title)}" loading="lazy">` : ''}
      </a>
      <div class="cart-drawer__details">
        <a class="cart-drawer__title" href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a>
        <div class="price">${formatMoney(item.final_line_price)}</div>
        ${item.variant_title ? `<div class="cart-drawer__size caption">Tamanho: ${escapeHTML(item.variant_title)}</div>` : ''}
        <div class="cart-drawer__qty" data-line-key="${escapeHTML(item.key)}">
          <button type="button" data-cart-qty="${item.quantity - 1}" aria-label="Diminuir quantidade">-</button>
          <span>${item.quantity}</span>
          <button type="button" data-cart-qty="${item.quantity + 1}" aria-label="Aumentar quantidade">+</button>
        </div>
      </div>
    </div>
  `).join('');
}

async function changeCartLine(key, quantity) {
  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  });
  const cart = await response.json();
  renderCart(cart);
}

async function refreshCart() {
  const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
  const cart = await response.json();
  renderCart(cart);
  return cart;
}

const cartRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
  ? window.Shopify.routes.root
  : '/';

const cartEndpoint = (path) => `${cartRoot}${path}`.replace(/\/{2,}/g, '/');

const shippingQuery = (zip) => {
  const params = new URLSearchParams();
  params.set('shipping_address[zip]', zip);
  params.set('shipping_address[country]', 'Brazil');
  return params.toString();
};

const setProductMedia = (section, targetMedia, targetThumb) => {
  if (!section || !targetMedia) return;
  section.querySelectorAll('[data-product-media]').forEach((media) => media.classList.remove('is-active'));
  targetMedia.classList.add('is-active');
  section.querySelectorAll('[data-product-thumb]').forEach((thumb) => thumb.classList.remove('is-active'));
  if (targetThumb) targetThumb.classList.add('is-active');
  const gallery = targetMedia.closest('.product-gallery__main--refined');
  if (gallery && window.matchMedia('(max-width: 860px)').matches) {
    targetMedia.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
  }
};

const waitForShippingRates = async (query, attempt = 0) => {
  const response = await fetch(`${cartEndpoint('cart/async_shipping_rates.json')}?${query}`, {
    headers: { Accept: 'application/json' }
  });
  const data = await response.json();
  if (data && Array.isArray(data.shipping_rates)) return data.shipping_rates;
  if (attempt >= 5) return [];
  await new Promise((resolve) => window.setTimeout(resolve, 650));
  return waitForShippingRates(query, attempt + 1);
};

const estimateCartShipping = async (button) => {
  const summary = button.closest('.cart-summary');
  const zipInput = summary && summary.querySelector('[data-cart-shipping-zip]');
  const results = summary && summary.querySelector('[data-cart-shipping-results]');
  const zip = zipInput && zipInput.value.replace(/\D/g, '');
  if (!zipInput || !results) return;

  if (!zip || zip.length < 8) {
    results.textContent = 'Digite um CEP válido para calcular.';
    zipInput.focus();
    return;
  }

  const originalText = button.textContent;
  const query = shippingQuery(zip);
  button.disabled = true;
  button.textContent = '...';
  results.textContent = 'Calculando opções para seu CEP.';

  try {
    await fetch(`${cartEndpoint('cart/prepare_shipping_rates.json')}?${query}`, {
      method: 'POST',
      headers: { Accept: 'application/json' }
    });
    const rates = await waitForShippingRates(query);

    results.innerHTML = rates.length
      ? rates.map((rate) => `
        <div class="cart-shipping-results__rate">
          <span>${escapeHTML(rate.presentment_name || rate.name)}</span>
          <strong>${formatMoney(Math.round(Number(rate.price || 0) * 100))}</strong>
        </div>
      `).join('')
      : 'Não encontramos opções de frete para esse CEP.';
  } catch (error) {
    results.textContent = 'Não foi possível calcular agora. O frete será confirmado no checkout.';
  } finally {
    button.disabled = false;
    button.textContent = originalText;
  }
};

document.addEventListener('click', (event) => {
  const desktopSubmenuToggle = event.target.closest('[data-submenu-group-toggle]');
  if (desktopSubmenuToggle) {
    event.preventDefault();
    event.stopPropagation();
    const group = desktopSubmenuToggle.closest('.site-nav__submenu-group');
    const links = group && group.querySelector('.site-nav__submenu-group-links');
    if (!group || !links) return;
    const isOpen = desktopSubmenuToggle.getAttribute('aria-expanded') === 'true';
    desktopSubmenuToggle.setAttribute('aria-expanded', String(!isOpen));
    links.hidden = isOpen;
    return;
  }

  const mobileMenuChild = event.target.closest('.mobile-menu-panel__child--has-children');
  if (mobileMenuChild) {
    const firstGrandchild = mobileMenuChild.nextElementSibling;
    if (firstGrandchild && firstGrandchild.classList.contains('mobile-menu-panel__grandchild')) {
      event.preventDefault();
      const isOpen = mobileMenuChild.classList.toggle('is-mobile-submenu-open');
      mobileMenuChild.setAttribute('aria-expanded', String(isOpen));
      let sibling = firstGrandchild;
      while (sibling && sibling.classList.contains('mobile-menu-panel__grandchild')) {
        sibling.classList.toggle('is-open', isOpen);
        sibling = sibling.nextElementSibling;
      }
      return;
    }
  }

  const mobileMenuParent = event.target.closest('.mobile-menu-panel__links > a:not(.mobile-menu-panel__child):not(.mobile-menu-panel__grandchild)');
  if (mobileMenuParent) {
    const firstChild = mobileMenuParent.nextElementSibling;
    if (firstChild && firstChild.classList.contains('mobile-menu-panel__child')) {
      event.preventDefault();
      const isOpen = mobileMenuParent.classList.toggle('is-mobile-submenu-open');
      mobileMenuParent.setAttribute('aria-expanded', String(isOpen));
      let sibling = firstChild;
      while (sibling && sibling.classList.contains('mobile-menu-panel__child')) {
        sibling.classList.toggle('is-open', isOpen);
        sibling.classList.remove('is-mobile-submenu-open');
        sibling.setAttribute('aria-expanded', 'false');
        let grandchild = sibling.nextElementSibling;
        while (grandchild && grandchild.classList.contains('mobile-menu-panel__grandchild')) {
          grandchild.classList.remove('is-open');
          grandchild = grandchild.nextElementSibling;
        }
        sibling = grandchild;
      }
      return;
    }
  }

  const headerSearchToggle = event.target.closest('[data-header-search-toggle]');
  if (headerSearchToggle) {
    const search = headerSearchToggle.closest('[data-header-search]');
    const input = search && search.querySelector('[data-header-search-input]');
    const isOpen = search && search.classList.toggle('is-open');
    headerSearchToggle.setAttribute('aria-expanded', String(Boolean(isOpen)));
    if (isOpen && input) window.setTimeout(() => input.focus(), 80);
    if (!isOpen) clearPredictiveResults();
    return;
  }

  if (!event.target.closest('[data-header-search]')) {
    document.querySelectorAll('[data-header-search].is-open').forEach((search) => {
      search.classList.remove('is-open');
      const toggle = search.querySelector('[data-header-search-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
    clearPredictiveResults();
  }

  const productThumb = event.target.closest('[data-product-thumb]');
  if (productThumb) {
    const section = productThumb.closest('[data-product-section]');
    const targetId = productThumb.dataset.mediaTarget;
    const targetMedia = targetId && section && section.querySelector(`#${window.CSS && CSS.escape ? CSS.escape(targetId) : targetId}`);
    setProductMedia(section, targetMedia, productThumb);
    return;
  }

  const optionButton = event.target.closest('[data-option-value]');
  if (optionButton) {
    if (optionButton.disabled) return;
    const section = optionButton.closest('[data-product-section]');
    const fieldset = optionButton.closest('[data-option-position]');
    if (!section || !fieldset) return;

    if (optionButton.classList.contains('is-selected')) {
      fieldset.querySelectorAll('[data-option-value]').forEach((button) => {
        button.classList.remove('is-selected');
        button.setAttribute('aria-pressed', 'false');
      });

      const idInput = section.querySelector('[data-variant-id]');
      const submit = section.querySelector('[data-product-submit]');
      if (idInput) idInput.value = '';
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Escolha o tamanho';
      }
      return;
    }

    fieldset.querySelectorAll('[data-option-value]').forEach((button) => {
      button.classList.remove('is-selected');
      button.setAttribute('aria-pressed', 'false');
    });
    optionButton.classList.add('is-selected');
    optionButton.setAttribute('aria-pressed', 'true');

    const variantsScript = section.querySelector('[data-product-variants]');
    const idInput = section.querySelector('[data-variant-id]');
    const submit = section.querySelector('[data-product-submit]');
    let variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const selectedOptions = Array.from(section.querySelectorAll('[data-option-position]')).map((group) => {
      const selected = group.querySelector('[data-option-value].is-selected');
      return selected && selected.dataset.optionValue;
    });

    const variant = variants.find((item) => {
      return selectedOptions.every((value, index) => item.options[index] === value);
    });

    if (variant && idInput) {
      idInput.value = variant.id;
    }
    if (submit && variant) {
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? 'Adicionar à sacola' : 'Esgotado';
    }
    return;
  }

  let toggleableRadio = event.target.closest('[data-product-card-variant], [data-product-card-set-variant], [data-pdp-look-variant]');
  if (!toggleableRadio) {
    const radioLabel = event.target.closest('.product-card__quick-size, .pdp-look-item__size');
    if (radioLabel) toggleableRadio = radioLabel.querySelector('input[type="radio"]');
  }
  if (toggleableRadio && toggleableRadio.type === 'radio' && toggleableRadio.dataset.wasChecked === 'true') {
    event.preventDefault();
    toggleableRadio.checked = false;
    toggleableRadio.dataset.wasChecked = 'false';

    const quickForm = toggleableRadio.closest('[data-product-card-form]');
    if (quickForm) {
      quickForm.classList.remove('is-selected');
    }
    return;
  }

  const quickSizeLabel = event.target.closest('.product-card__quick-size');
  if (quickSizeLabel) {
    const radio = quickSizeLabel.querySelector('input[type="radio"]');
    if (radio && !radio.disabled && radio.dataset.wasChecked === 'true') {
      event.preventDefault();
      radio.checked = false;
      radio.dataset.wasChecked = 'false';
      const quickForm = radio.closest('[data-product-card-form]');
      if (quickForm) quickForm.classList.remove('is-selected');
      return;
    }
  }

  const toggle = event.target.closest('[data-mobile-menu-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;
    const isOpen = menu.hasAttribute('hidden');
    menu.toggleAttribute('hidden', !isOpen);
    toggle.setAttribute('aria-expanded', String(isOpen));
    if (isOpen) {
      menu.querySelectorAll('.is-mobile-submenu-open').forEach((item) => {
        item.classList.remove('is-mobile-submenu-open');
        item.setAttribute('aria-expanded', 'false');
      });
      menu.querySelectorAll('.mobile-menu-panel__child.is-open, .mobile-menu-panel__grandchild.is-open').forEach((item) => item.classList.remove('is-open'));
    }
    return;
  }

  if (event.target.closest('[data-cart-open]')) {
    if (document.body.classList.contains('cart-drawer-disabled')) return;
    event.preventDefault();
    refreshCart().finally(openCartDrawer);
    return;
  }

  if (event.target.closest('[data-cart-close]')) {
    closeCartDrawer();
    return;
  }

  if (event.target.closest('[data-search-open]')) {
    event.preventDefault();
    openSearchDrawer();
    return;
  }

  if (event.target.closest('[data-search-close]')) {
    closeSearchDrawer();
    return;
  }

  const qtyButton = event.target.closest('[data-cart-qty]');
  if (qtyButton) {
    const key = qtyButton.closest('[data-line-key]').dataset.lineKey;
    const quantity = Math.max(Number(qtyButton.dataset.cartQty), 0);
    changeCartLine(key, quantity).catch(refreshCart);
    return;
  }

  const cartPageQtyButton = event.target.closest('[data-cart-page-qty]');
  if (cartPageQtyButton) {
    const item = cartPageQtyButton.closest('.cart-item');
    const input = item && item.querySelector('.cart-item__quantity-input');
    if (!input) return;
    const nextValue = Math.max(Number(input.value || 0) + Number(cartPageQtyButton.dataset.cartPageQty), 0);
    input.value = nextValue;
    item.querySelectorAll('.cart-item__quantity-value').forEach((value) => { value.textContent = nextValue; });
    const key = item.dataset.lineKey;
    if (key) {
      cartPageQtyButton.disabled = true;
      changeCartLine(key, nextValue)
        .then(() => { window.location.reload(); })
        .catch(() => {
          input.dispatchEvent(new Event('change', { bubbles: true }));
          const form = item.closest('form');
          if (form) form.requestSubmit();
        });
    } else {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return;
  }

  const removeButton = event.target.closest('[data-cart-remove]');
  if (removeButton) {
    changeCartLine(removeButton.dataset.lineKey, 0).catch(refreshCart);
    return;
  }

  const shippingButton = event.target.closest('[data-cart-shipping-calculate]');
  if (shippingButton) {
    estimateCartShipping(shippingButton);
    return;
  }

  const discountButton = event.target.closest('[data-cart-discount-apply]');
  if (discountButton) {
    const summary = discountButton.closest('.cart-summary');
    const input = summary && summary.querySelector('[data-cart-discount-code]');
    const code = input && input.value.trim();
    if (!code) {
      if (input) input.focus();
      return;
    }
    window.location.href = `${cartEndpoint(`discount/${encodeURIComponent(code)}`)}?redirect=/checkout`;
    return;
  }

  const filterToggle = event.target.closest('[data-filter-toggle]');
  if (filterToggle) {
    const panel = document.querySelector('[data-filter-panel]');
    if (panel) {
      const isOpen = panel.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', String(isOpen));
    }
  }

  const loadMoreButton = event.target.closest('[data-load-more]');
  if (loadMoreButton) {
    const wrapper = loadMoreButton.closest('[data-load-more-wrapper]');
    const grid = document.querySelector('.product-grid--collection');
    const nextUrl = wrapper && wrapper.dataset.nextUrl;
    if (!wrapper || !grid || !nextUrl || loadMoreButton.classList.contains('is-loading')) return;

    const originalText = loadMoreButton.textContent;
    loadMoreButton.classList.add('is-loading');
    loadMoreButton.textContent = 'Carregando';

    fetch(nextUrl, { headers: { Accept: 'text/html' } })
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextItems = doc.querySelectorAll('.product-grid--collection .product-grid__item');
        const nextWrapper = doc.querySelector('[data-load-more-wrapper]');
        nextItems.forEach((item, index) => {
          item.classList.add('is-loading-in');
          item.style.animationDelay = `${Math.min(index, 8) * 45}ms`;
          grid.appendChild(item);
        });

        const followingUrl = nextWrapper && nextWrapper.dataset.nextUrl;
        if (followingUrl) {
          wrapper.dataset.nextUrl = followingUrl;
          loadMoreButton.classList.remove('is-loading');
          loadMoreButton.textContent = originalText || 'Ver mais produtos';
        } else {
          wrapper.remove();
        }
      })
      .catch(() => {
        window.location.href = nextUrl;
      });
  }
});

let productGalleryScrollTimer = null;

document.addEventListener('scroll', (event) => {
  const gallery = event.target.closest && event.target.closest('.product-gallery__main--refined');
  if (!gallery || !window.matchMedia('(max-width: 860px)').matches) return;
  window.clearTimeout(productGalleryScrollTimer);
  productGalleryScrollTimer = window.setTimeout(() => {
    const section = gallery.closest('[data-product-section]');
    const mediaItems = [...gallery.querySelectorAll('[data-product-media]')];
    if (!section || mediaItems.length < 2) return;
    const activeIndex = Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth));
    const activeMedia = mediaItems[Math.max(0, Math.min(mediaItems.length - 1, activeIndex))];
    const activeThumb = activeMedia && section.querySelector(`[data-product-thumb][data-media-target="${activeMedia.id}"]`);
    mediaItems.forEach((media) => media.classList.toggle('is-active', media === activeMedia));
    section.querySelectorAll('[data-product-thumb]').forEach((thumb) => thumb.classList.toggle('is-active', thumb === activeThumb));
  }, 140);
}, true);

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-header-search].is-open').forEach((search) => {
    search.classList.remove('is-open');
    const toggle = search.querySelector('[data-header-search-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  });
  closeCartDrawer();
  closeSearchDrawer();
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-product-card-form]');
  if (!form) return;

  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  const buttonText = button && button.textContent;
  if (button) button.textContent = 'Adicionando';

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });
    await refreshCart();
    openCartDrawer();
  } catch (error) {
    form.submit();
  } finally {
    if (button) button.textContent = buttonText || 'Adicionar à sacola';
  }
});

document.addEventListener('click', async (event) => {
  const shareButton = event.target.closest('[data-product-share]');
  if (shareButton) {
    const shareData = {
      title: shareButton.dataset.shareTitle || document.title,
      url: shareButton.dataset.shareUrl || window.location.href
    };
    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else if (navigator.clipboard) {
        await navigator.clipboard.writeText(shareData.url);
        shareButton.classList.add('is-copied');
        const label = shareButton.querySelector('span');
        const originalLabel = label && label.textContent;
        if (label) label.textContent = 'Link copiado';
        window.setTimeout(() => {
          shareButton.classList.remove('is-copied');
          if (label) label.textContent = originalLabel || 'Compartilhar';
        }, 1800);
      }
    } catch (error) {
      return;
    }
    return;
  }

  const button = event.target.closest('[data-product-card-set-submit]');
  if (!button) return;

  const set = button.closest('[data-product-card-set]');
  const status = set && set.querySelector('[data-product-card-set-status]');
  if (!set) return;

  const selectedVariants = [...set.querySelectorAll('[data-product-card-set-variant]')]
    .filter((input) => input.type === 'hidden' || input.checked)
    .map((input) => input.value)
    .filter(Boolean);

  if (!selectedVariants.length) {
    if (status) status.textContent = 'Escolha um tamanho para adicionar à sacola.';
    return;
  }

  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = 'Adicionando';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: selectedVariants.map((id) => ({ id: Number(id), quantity: 1 }))
      })
    });
    if (!response.ok) throw new Error('Set quick add failed');
    if (status) status.textContent = selectedVariants.length > 1 ? 'Peças adicionadas à sacola.' : 'Peça adicionada à sacola.';
    await refreshCart();
    openCartDrawer();
  } catch (error) {
    if (status) status.textContent = 'Não foi possível adicionar agora.';
  } finally {
    button.disabled = false;
    button.textContent = originalText || 'Adicionar à sacola';
  }
});

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-pdp-look-group-submit]');
  if (!button) return;

  const group = button.closest('[data-pdp-look-group]');
  const status = group && group.querySelector('[data-pdp-look-group-status]');
  if (!group) return;

  const variantIds = [...group.querySelectorAll('[data-pdp-look-variant]')]
    .filter((input) => input.type === 'hidden' || input.checked)
    .map((input) => input.value)
    .filter(Boolean);

  if (!variantIds.length) {
    if (status) status.textContent = 'Escolha ao menos uma peça para adicionar à sacola.';
    return;
  }
  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = 'Adicionando';
  if (status) status.textContent = '';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [...new Set(variantIds)].map((id) => ({ id: Number(id), quantity: 1 }))
      })
    });
    if (!response.ok) throw new Error('PDP look add failed');
    if (status) status.textContent = 'Seleção adicionada à sacola.';
    await refreshCart();
    openCartDrawer();
  } catch (error) {
    if (status) status.textContent = 'Não foi possível adicionar agora.';
  } finally {
    button.disabled = false;
    button.textContent = originalText || 'Adicionar à sacola';
  }
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-product-form]');
  if (!form) return;

  event.preventDefault();
  const button = form.querySelector('[data-product-submit]');
  const originalText = button && button.textContent;
  if (button) {
    button.disabled = true;
    button.textContent = 'Adicionando';
  }

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });
    await refreshCart();
    openCartDrawer();
  } catch (error) {
    form.submit();
  } finally {
    if (button) {
      button.disabled = false;
      button.textContent = originalText || 'Adicionar à sacola';
    }
  }
});

document.addEventListener('pointermove', (event) => {
  if (event.pointerType && event.pointerType !== 'mouse') return;
  const galleryMain = event.target.closest('.product-gallery__main--refined');
  if (!galleryMain) return;
  const image = galleryMain.querySelector('[data-product-media].is-active[data-media-type="image"] [data-product-main-image]');
  if (!image) return;

  const rect = galleryMain.getBoundingClientRect();
  const x = Math.max(0, Math.min(100, ((event.clientX - rect.left) / rect.width) * 100));
  const y = Math.max(0, Math.min(100, ((event.clientY - rect.top) / rect.height) * 100));
  image.style.transformOrigin = `${x}% ${y}%`;
});

document.addEventListener('pointerdown', (event) => {
  let toggleableRadio = event.target.closest('[data-product-card-variant], [data-product-card-set-variant], [data-pdp-look-variant]');
  if (!toggleableRadio) {
    const radioLabel = event.target.closest('.product-card__quick-size, .pdp-look-item__size');
    if (radioLabel) toggleableRadio = radioLabel.querySelector('input[type="radio"]');
  }
  if (toggleableRadio && toggleableRadio.type === 'radio') {
    toggleableRadio.dataset.wasChecked = toggleableRadio.checked ? 'true' : 'false';
  }

  if (event.pointerType && event.pointerType !== 'mouse') return;
  const galleryMain = event.target.closest('.product-gallery__main--refined');
  if (galleryMain) galleryMain.classList.add('is-touch-zoom');
});

function markToggleableRadioState(event) {
  let toggleableRadio = event.target.closest('[data-product-card-variant], [data-product-card-set-variant], [data-pdp-look-variant]');
  if (!toggleableRadio) {
    const radioLabel = event.target.closest('.product-card__quick-size, .pdp-look-item__size');
    if (radioLabel) toggleableRadio = radioLabel.querySelector('input[type="radio"]');
  }
  if (toggleableRadio && toggleableRadio.type === 'radio') {
    toggleableRadio.dataset.wasChecked = toggleableRadio.checked ? 'true' : 'false';
  }
}

document.addEventListener('mousedown', markToggleableRadioState);
document.addEventListener('touchstart', markToggleableRadioState, { passive: true });

document.addEventListener('pointerup', (event) => {
  document.querySelectorAll('.product-gallery__main--refined.is-touch-zoom').forEach((galleryMain) => {
    window.setTimeout(() => galleryMain.classList.remove('is-touch-zoom'), 180);
  });
});

document.addEventListener('input', (event) => {
  const input = event.target.closest('[data-predictive-search-input]');
  if (!input) return;

  const query = input.value.trim();
  window.clearTimeout(predictiveSearchTimer);

  if (query.length < 2) {
    clearPredictiveResults(input);
    return;
  }

  predictiveSearchTimer = window.setTimeout(() => {
    fetchPredictiveSearch(query, input).catch((error) => {
      if (error.name !== 'AbortError') clearPredictiveResults(input);
    });
  }, 180);
});

document.addEventListener('change', (event) => {
  const quickVariant = event.target.closest('[data-product-card-variant]');
  if (quickVariant) {
    const quickForm = quickVariant.closest('[data-product-card-form]');
    if (quickForm) quickForm.classList.toggle('is-selected', Boolean(quickForm.querySelector('[data-product-card-variant]:checked')));
    return;
  }

  const select = event.target.closest('[data-variant-select]');
  if (!select) return;

  const form = select.closest('form');
  const idInput = form && form.querySelector('input[name="id"]');
  if (idInput) idInput.value = select.value;
});

const header = document.querySelector('[data-site-header]');
function updateAnnouncementHeight() {
  const announcement = document.querySelector('[data-announcement-bar]');
  const announcementHeight = announcement ? announcement.offsetHeight : 0;
  const headerHeight = header ? header.offsetHeight : 0;
  document.documentElement.style.setProperty('--announcement-bar-height', `${announcementHeight}px`);
  document.documentElement.style.setProperty('--site-header-height', `${headerHeight}px`);
}
function updateHeader() {
  if (!header) return;
  const isScrolled = window.scrollY > 24;
  header.classList.toggle('site-header--scrolled', isScrolled);
  document.documentElement.classList.toggle('announcement-bar-hidden', isScrolled);
}
updateAnnouncementHeight();
updateHeader();
window.addEventListener('resize', updateAnnouncementHeight, { passive: true });
window.addEventListener('scroll', updateHeader, { passive: true });
document.addEventListener('shopify:section:load', updateAnnouncementHeight);
document.addEventListener('shopify:section:unload', updateAnnouncementHeight);

const magneticLogo = document.querySelector('[data-magnetic-logo]');
if (magneticLogo && window.matchMedia('(pointer: fine)').matches) {
  const inner = magneticLogo.querySelector('.magnetic-logo__inner');
  magneticLogo.addEventListener('mousemove', (event) => {
    const rect = magneticLogo.getBoundingClientRect();
    const x = event.clientX - rect.left - rect.width / 2;
    const y = event.clientY - rect.top - rect.height / 2;
    inner.style.transform = `translate(${x * 0.16}px, ${y * 0.28}px)`;
  });
  magneticLogo.addEventListener('mouseleave', () => {
    inner.style.transform = 'translate(0, 0)';
  });
}

const revealEls = document.querySelectorAll('[data-reveal], .product-card, .look-card, .editorial-band, .manifesto__grid');
if (!reduceMotion && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.14 });
  revealEls.forEach((el) => {
    el.classList.add('reveal-item');
    observer.observe(el);
  });
} else {
  revealEls.forEach((el) => el.classList.add('is-visible'));
}

refreshCart().catch(() => {});
